import {useParams} from "react-router-dom";
import {getAxiosInstance} from "../../utils/axiosInstance";
import {useEffect, useState} from "react";
import {toast} from "react-toastify";
import {useTranslation} from "react-i18next";
import {TFunction} from "i18next";
import {SortParams} from "../../components/Table";
import SearchTable from "../../components/SearchTable";
import {Icon, Input, InputGroup, InputLeftElement, Text} from "@chakra-ui/react";
import InventoryModal from "./components/InventoryModal";
import CategorySelect from "../../components/CategorySelect";
import {SearchIcon} from "@chakra-ui/icons";

const getColumns = (t: TFunction) => [
    {
        Header: t("PRODUCT_NAME"),
        accessor: 'productName',
        isSortable: true
    },
    {
        Header: t("QUANTITY"),
        accessor: 'quantity',
        isSortable: true
    },
];

type InventoryEntry = {
    id: string;
    quantity: number;
    productId: string;
    productName: string;
    providerId: string;
}

const PlaceOfBusiness = () => {
    const {id} = useParams();
    const {t} = useTranslation("translations");

    const [inventoryEntries, setInventoryEntries] = useState<InventoryEntry[]>([]);
    const [placeOfBusiness, setPlaceOfBusiness] = useState<any | null>(null);
    const [selectedInventoryEntry, setSelectedInventoryEntry] = useState<any | null>(null);

    // Pagination, sorting and search
    const [page, setPage] = useState<number>(1);
    const [perPage, setPerPage] = useState<number>(10);
    const [search, setSearch] = useState<string>("");
    const [sortParmas, setSortParams] = useState<SortParams | null>(null);
    const [sku, setSku] = useState<string>("");
    const [length, setLength] = useState<number>(10);

    const [mainCategoryId, setMainCategoryId] = useState<string | undefined>();
    const [subCategoriesIds, setSubCategoriesIds] = useState<string[]>([]);

    const fetch = async (
        currentPage: number = 1,
        perPage: number = 10,
        search: string | undefined,
        sortParams: SortParams | null,
        searchField?: string,
    ) => {
        try {
            const res = await getAxiosInstance().get("/Inventory/PlaceOfBusiness/" + id, {
                params: {
                    PageNumber: currentPage,
                    PageSize: perPage,
                    SearchString: search?.toLowerCase(),
                    SearchField: search ? (searchField ?? "NormalizeName") : undefined,
                    SortBy: sortParams ? sortParams.sortBy : undefined,
                    SortDesc: sortParams ? sortParams.isSortedDesc : undefined,
                    categoryId: mainCategoryId,
                    categoriesIds: subCategoriesIds
                },
                paramsSerializer: {
                    indexes: true,
                }
            });
            console.log("JSON ", res.headers.pagination, res.data)
            setInventoryEntries(res.data);
            const paginationData = JSON.parse(res.headers.pagination);
            setLength(paginationData.totalItems);
        } catch (e) {
            toast.error(t("FETCH_ERROR"), {position: "bottom-right"});
        }
    }

    const fetchPlaceOfBusiness = async () => {
        try {
            const res = await getAxiosInstance().get("/Companies/place-of-business/" + id);
            setPlaceOfBusiness(res.data);
        } catch (e) {
            toast.error(t("FETCH_ERROR"), {position: "bottom-right"});
        }
    }

    useEffect(() => {
        fetchPlaceOfBusiness().then();
    }, [id]);

    useEffect(() => {
        fetch(1, 10, search, sortParmas).then();
    }, [mainCategoryId, subCategoriesIds]);

    useEffect(() => {
        if (sku.length >= 1) {
            fetch(1, 10, sku, sortParmas, "SKU").then();
        } else {
            fetch(1, 10, "", null);
        }
    }, [sku]);

    return (
        <div>
            <Text padding="2" ml={3} fontSize="3xl" className="flex flex-col md:flex-row">
                {t("INVENTORY_PAGE_HEAD")}:
                <Text color="teal.300"
                      className="ml-2">{placeOfBusiness ? `${placeOfBusiness.name} ( ${placeOfBusiness.companyName} )` : "-"}</Text>
            </Text>
            <SearchTable
                columns={getColumns(t)}
                data={inventoryEntries}
                dataLength={length}
                onRowClick={(data) => setSelectedInventoryEntry(data)}
                fetchData={(data) => fetch(data.page, data.perPage, data.searchTerm, data.sortParams)}
                page={page}
                perPage={perPage}
                setPage={setPage}
                setPerPage={setPerPage}
                search={search}
                setSearch={setSearch}
                sortParams={sortParmas}
                setSortParams={setSortParams}
                disableMainSearch={sku.length > 0}
                additionFields={
                    <>
                        <div className="w-full flex flex-col md:flex-row mx-2 my-2 md:my-0">
                            <InputGroup size='md' className="mx-2">
                                <InputLeftElement pointerEvents='none'>
                                    <Icon as={SearchIcon} className="m-2"/>
                                </InputLeftElement>
                                <Input
                                    pr='4.5rem'
                                    type='text'
                                    disabled={search.length > 0}
                                    value={sku}
                                    onChange={(e) => setSku(e.target.value)}
                                    placeholder='SKU'

                                />
                            </InputGroup>
                        </div>
                        <CategorySelect
                            mainCategory={mainCategoryId}
                            onCategorySelect={(value) => setMainCategoryId(value)}
                            subCategory={subCategoriesIds}
                            onSubCategorySelect={(values) => {
                                setSubCategoriesIds([...values]);
                            }}
                        />
                    </>
                }
            />
            <InventoryModal
                open={selectedInventoryEntry}
                onClose={() => setSelectedInventoryEntry(null)}
                id={selectedInventoryEntry?.productId}
                placeOfBusinessId={id}
                name={placeOfBusiness ? `(${placeOfBusiness.name} - ${placeOfBusiness.companyName})` : "-"}
            />
        </div>
    )
};


export default PlaceOfBusiness;